import { configureStore } from '@reduxjs/toolkit';
import deafultActorsSlice from '../features/deafultActorsSlice';
import addedActors from '../features/addedActorsSlice';
import addedZwrotAkcji from '../features/addedZwrotAkcjiSlice';
import addedPytanie from '../features/addedPytanieSlice';
export default configureStore({
  reducer: {
    deafultActors: deafultActorsSlice, // to sie wiaze z nazwa w reduxDevTools, to jest jakby rootReducer?
    addedActors: addedActors,
    addedZwrotAkcji: addedZwrotAkcji,
    addedPytanie: addedPytanie
  },
});
